import {Box, Grid, useMediaQuery, useTheme} from '@mui/material';
import {numberWithCommas} from '../../../Helpers/stringFormat';
import DetailData from '../../DetailData';
import {Language} from '../../../context/LanguageContext';
import {DoughnutChart} from '../../../components';

export default function KeluasanLadang({
  mapData,
  doughnutData,
  zoomer,
  groupName,
  resLuasLadangHa,
  resLuasLadangAc,
  resLuasBerhasil,
  resLuasBertanam,
  mapRef,
  setPkCode,
  setNegeriCode,
  setProjectCode,
  setMarkerClick,
}) {
  const theme = useTheme();
  const {newObj, language} = Language();
  const isXsScreen = useMediaQuery(theme.breakpoints.between('xs', 'sm'));
  const isSmScreen = useMediaQuery(theme.breakpoints.between('sm', 'md'));
  // DOUGHNUT OPTIONS
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    responsiveAnimationDuration: 0,
    aspectRatio: 1,
    width: '100%',
    plugins: {
      legend: {
        display: false, // set this to false to hide the legend
      },
    },
  };
  return (
    <Box
      sx={{
        position: 'relative',
        display: 'block',
        justifyContent: 'center',
        alignCenter: 'center',
        height: 'calc(100% - 70px)',
        overflowY: 'scroll',
      }}
    >
      <div
        style={{
          backgroundColor: '#ceb889',
          borderRadius: '10px 10px 0 0',
        }}
      >
        <div style={{padding: '20px'}}>
          <div style={{fontWeight: 'bold'}}>
            {newObj.JumlahKeluasanKawasanWord[language]}
          </div>

          <Grid
            container
            rowSpacing={1}
            columnSpacing={{xs: 1, sm: 2, md: 2}}
            my={2}
            sx={{
              height: '200px',
              marginTop: '-15px',
              marginBottom: '-15px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Grid
              item
              xs={5}
              px={1}
              sx={{
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <div
                style={{
                  height: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: isSmScreen || isXsScreen ? '120px' : '100%',
                  // padding: isSmScreen || isXsScreen ? "30px" : "0px",
                }}
              >
                <DoughnutChart data={doughnutData} options={options} />
              </div>
            </Grid>
            <Grid
              item
              xs={7}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
              }}
            >
              <div style={{fontSize: '12px'}}>
                {newObj.LuasLadangWord[language]}
                <br />
                <b style={{fontSize: '12px'}}>
                  {numberWithCommas(resLuasLadangHa)} ha /{' '}
                  {numberWithCommas(resLuasLadangAc)} ac
                </b>
              </div>
              <br />
              <Grid container>
                <Grid item xs={1}>
                  <div className='border red'></div>
                </Grid>
                <Grid item xs={11} pl={1}>
                  <div variant='caption' style={{fontSize: '12px'}}>
                    {newObj.LuasBertanamWord[language]} <br />
                    <b className='red' style={{fontSize: '12px'}}>
                      {numberWithCommas(resLuasBertanam)} ha
                    </b>
                  </div>
                </Grid>
              </Grid>
              <br />
              <Grid container component='main'>
                <Grid item xs={1}>
                  <div className='border blue'></div>
                </Grid>
                <Grid item xs={11} pl={1}>
                  <div variant='caption' style={{fontSize: '12px'}}>
                    {newObj.LuasBerhasilWord[language]} <br />
                    <b className='blue' style={{fontSize: '12px'}}>
                      {numberWithCommas(resLuasBerhasil)} ha
                    </b>
                  </div>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </div>
      </div>

      <Grid
        className='removeScrollbar'
        pb={5}
        sx={{
          background: 'rgba(255, 255, 255, 0.6)',
          backdropFilter: 'blur(10px)',
          boxShadow: '0 4px 30px rgba(0, 0, 0, 0.1)',
          minHeight: 'calc(100% - 230px)',
          flex: '1 1 auto',
        }}
      >
        <DetailData
          data={mapData}
          zoom={zoomer}
          groupName={groupName}
          mapRef={mapRef}
          setPkCode={setPkCode}
          setNegeriCode={setNegeriCode}
          setProjectCode={setProjectCode}
          setMarkerClick={setMarkerClick}
        />
      </Grid>
    </Box>
  );
}
